<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/contactus' }">聯絡資訊</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          聯絡資訊 <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <h2>羅東林管處</h2>
          <p>
            <ul>
              <li>縣市：宜蘭縣</li>
              <li>地址：26548 宜蘭縣羅東鎮中正北路118號</li>
              <li>電話：03-9545114</li>
              <li>相關資訊：羅東林管處</li>
              <li>北緯(WGS84)：24.683462</li>
              <li>東經(WGS84)：121.773255</li>
              <li>相關連結：<a href="https://luodong.forest.gov.tw/">https://luodong.forest.gov.tw/</a></li>
            </ul>
          </p>
          <h2>台北工作站</h2>
          <p>
            <ul>
              <li>縣市：台北市</li>
              <li>地址：10642 台北市潮州街61之3號</li>
              <li>電話：02-23958886</li>
              <li>北緯(WGS84)：25.029408</li>
              <li>東經(WGS84)：121.524389</li>
            </ul>
          </p>
          <h2>礁溪工作站</h2>
          <p>
            <ul>
              <li>縣市：宜蘭縣</li>
              <li>地址：26241 宜蘭縣礁溪鄉玉石村忠孝路127號</li>
              <li>電話：03-9882514</li>
              <li>北緯(WGS84)：24.832818</li>
              <li>東經(WGS84)：121.774092</li>
            </ul>
          </p>
          <h2>太平山工作站</h2>
          <p>
            <ul>
              <li>縣市：宜蘭縣</li>
              <li>地址：26742 宜蘭縣大同鄉泰雅路4段48號</li>
              <li>電話：03-9809618</li>
              <li>北緯(WGS84)：24.574878</li>
              <li>東經(WGS84)：121.478960</li>
            </ul>
          </p>
          <h2>冬山工作站</h2>
          <p>
            <ul>
              <li>縣市：宜蘭縣</li>
              <li>地址：26944 宜蘭縣南澳鄉東岳村新寮二路688號</li>
              <li>電話：03-9580169</li>
              <li>北緯(WGS84)：24.603245</li>
              <li>東經(WGS84)：121.743536</li>
            </ul>
          </p>
          <h2>南澳工作站</h2>
          <p>
            <ul>
              <li>縣市：宜蘭縣</li>
              <li>地址：27244 宜蘭縣南澳鄉中正路55號</li>
              <li>電話：03-9981060</li>
              <li>北緯(WGS84)：24.468535</li>
              <li>東經(WGS84)：121.792381</li>
            </ul>
          </p>
        </section>        
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';

  export default {
    name: 'news',
    components: {
      HeaderSlide,
    },
    async created () {
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
      }
    }
  }
</script>

<style>
  .accesskey-content{
    color: white;
  }
</style>